export const checkSelected = (collections, selectedValues) => {
    return collections && collections.length
        ? collections.map((collection) => ({
              ...collection,
              checked: Boolean(selectedValues && selectedValues.includes(collection.key))
          }))
        : [];
};
